<style lang="less" rel="stylesheet/less" type="text/less" scoped>


</style>

<template>
    <div class="customer-material-3D-edit">

        <el-form :model="formValidate" ref="formValidate" label-width="100px" class="demo-ruleForm">
            <el-form-item label="2D素材名称" prop="name">
                <el-col :span="12">
                    <el-input v-model="formValidate.name" placeholder="请输入素材名称"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="镜框图片" prop="frame_img">
                <el-upload class="upload-demo"
                        :before-upload="file=>fileChange(file,'frame_img','file_info')"
                        :limit="1"
                        accept="image/jpg, image/jpeg, image/png"
                        action="//fake_upload_url/">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <!-- <div class="license-tip" slot="tip" v-if="file_info.frame_name">{{ file_info.frame_name }}</div> -->
                </el-upload>
                <img v-if="file_info.frame_url" :src="file_info.frame_url" style="width:250px;">
                <img ref="frame" alt="" v-show="!file_info.frame_url" class="preview-image">
            </el-form-item>

             <el-form-item label="镜腿图片" prop="temple_img">
                <el-upload class="upload-demo"
                        :before-upload="file=>fileChange(file,'temple_img','file_info')"
                        :limit="1"
                        accept="image/jpg, image/jpeg, image/png"
                        action="//fake_upload_url/">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <!-- <div class="license-tip" slot="tip" v-if="file_info.temple_name">{{ file_info.temple_name }}</div> -->
                </el-upload>
                <img v-if="file_info.temple_url" :src="file_info.temple_url" style="width:250px;">
                <img ref="temple" alt="" v-show="!file_info.temple_url" class="preview-image">
            </el-form-item>

            <el-form-item>
                 <el-button type="primary" @click="updateMaterial">确定</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>

// import API_LIST from 'src/API_LIST';

import { getUploadImage } from '../../../../utils/utils.js';

export default {

    name: 'admin-material-3D-edit',

    props: ['materialDetail'],

    data() {

        return {
			token:'',

            formValidate : {

                name: '',

                frame_img : '',

                temple_img : '',

            },

            formLabelWidth: '120px',

             // 文件信息
            file_info : {

                frame_name : '',

                temple_name : '',

                frame_url: '',

                temple_url: '',


            }


        };

    },

    watch: {

        'materialDetail' : function(){

            if( this.materialDetail ) {

                this.initialValue();

            }

        }
    },
	 created() {
		this.token = sessionStorage.getItem("token");
	  },
    methods: {

        /**
         * 初始值
         * @return {undefined}
         */
        initialValue(){
            this.formValidate.name = this.materialDetail.name;

            this.formValidate.frame_img = this.materialDetail.frame_img;

            this.formValidate.temple_img = this.materialDetail.temple_img;



            this.file_info.frame_url = this.materialDetail.frame_img;

            this.file_info.temple_url = this.materialDetail.temple_img;


        },

        /**
         * file类型input改变
         * @param  {Object} file {选择的文件对象}
         * @return {Boolean} {false则会停止上传}
         */
        fileChange(file,param,info){

            switch(param) {

                case 'frame_img' :

                    this[info].frame_name = file.name;

                    getUploadImage(file,this.$refs.frame);

                    this[info].frame_url = '';

                    break;

                case 'temple_img' :

                    this[info].temple_name = file.name;

                    getUploadImage(file,this.$refs.temple);

                    this[info].temple_url = '';

                    break;

            }

            this.formValidate[param] = file;

            return false;

        },

        /**
         * 重置素材信息
         * @return {undefined}
         */
        resetMaterialInfo(){

            this.file_info.temple_name = this.file_info.frame_name = '';

        },

        /**
         * 更新素材信息
         * @return {undefined}
         */
        updateMaterial(){

            this.resetMaterialInfo();

            this.$emit('update',this.materialDetail.id,this.formDataCreate());

        },

        /**
         * 手动拼接formdata数据
         * @return {Object}
         */
        formDataCreate(){

            const new_object = {

                _method : 'PUT',
				token:this.token,
                name : this.formValidate.name,

                frame_img : this.formValidate.frame_img,

                temple_img : this.formValidate.temple_img,

            };

            let form_data = new FormData();

            Object.keys(new_object).forEach((key)=>{

                form_data.append( key , new_object[key] );

            });

            return form_data;

        }

    }
}
</script>
